<template>
  <div class="layout__content">
    <template v-if="!isLoading">
      <Teleport to="#top-menu-bar" defer>
        <PageTopBar v-if="isReady">
          <template #buttons>
            <slot name="pre-buttons" />
            <BaseButton
              variant="primary"
              size="small"
              icon="fa-solid fa-save"
              :outlined="dv.hasValidationErrors"
              :loading="dv.isSaving"
              :disabled="dv.isSaving || dv.hasValidationErrors || saveDisabled"
              @click="$emit('save')"
            >
              {{ saveButtonText }}
            </BaseButton>
            <slot name="action-buttons" />
          </template>
          <template #notifications>
            <div
              v-if="dv.hasValidationErrors"
              class="notification is-danger is-light is-size-7 p-2 m-0"
            >
              <span class="icon">
                <i class="fa-solid fa-exclamation-triangle" />
              </span>
              <span class="text has-text-weight-semibold">
                Please fix all validation errors.
              </span>
            </div>
            <slot
              v-if="dv.displayAnnotationNotification"
              name="clone-annotations"
              :dv="dv"
            >
              <div class="notification is-fullwidth is-info is-size-7 p-2 m-0">
                <span class="icon">
                  <i class="fa-solid fa-info" />
                </span>
                <span class="text has-text-weight-semibold">
                  {{ dv.keptAnnotationKeys.length }}
                  {{
                    dv.keptAnnotationKeys.length === 1
                      ? 'annotation'
                      : 'annotations'
                  }}
                  will be transferred to the new item:
                  <!-- eslint-disable vue/no-v-html -->
                  <span
                    class="has-text-weight-normal"
                    v-html="dv.keptAnnotationsStr"
                  ></span>
                  <!-- eslint-enable vue/no-v-html -->
                </span>
              </div>
            </slot>
            <slot name="extra-notifications" />
          </template>
        </PageTopBar>
      </Teleport>
      <!-- content -->
      <fieldset v-if="isReady" :disabled="dv.isSaving" class="shell-content">
        <slot />
      </fieldset>
    </template>
  </div>
</template>

<script>
import { computed, provide } from 'vue'

import { usePageShell } from '@/composables/usePageShell'

import PageTopBar from '@/components/PageTopBar.vue'

export default {
  name: 'NewItemShell',
  components: {
    PageTopBar,
  },
  props: {
    dv: { type: Object, required: true },
    pageTitle: { type: String, default: '' },
    saveButtonText: { type: String, default: 'Save Item' },
    saveDisabled: { type: Boolean, default: false },
  },
  emits: ['save'],
  setup(props) {
    provide('fieldPage', 'new')

    const resolvedTitle = computed(
      () =>
        props.pageTitle ||
        (props.dv.modelLabel ? `New ${props.dv.modelLabel}` : ''),
    )
    const isLoading = computed(
      () => !props.dv.isMetaReady || props.dv.isLoadingRecord,
    )
    const showProgress = computed(() => isLoading.value || props.dv.isSaving)
    usePageShell({ title: resolvedTitle, loading: showProgress })
    const isReady = computed(
      () => props.dv.isMetaReady && props.dv.isRecordReady,
    )

    return { isLoading, isReady }
  },
}
</script>

<style scoped>
.layout__content {
  display: contents;
}
</style>
